import LogRocket from 'logrocket';

/**
 * Initialize LogRocket for session recording and analytics
 * Should be called once at app startup
 */
export const initializeLogRocket = () => {
  try {
    // Initialize LogRocket with your app ID
    LogRocket.init('01fg9n/mathscampus');

    console.log('✅ LogRocket initialized successfully');
  } catch (error) {
    console.error('❌ Failed to initialize LogRocket:', error);
  }
};

export default LogRocket;